module.exports = __webpack_public_path__ + "static/media/2whitepine1text.8deaa4dd.jpg";